var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBatch = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-188"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-188",
    cx: 252.17,
    cy: 350.23,
    rx: 230.3,
    ry: 132.96,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-188"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-188",
    cx: 407.37,
    cy: 406.65,
    rx: 38.63,
    ry: 24,
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-188"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253,340l.36-6.65s-.62-12.31-9.61-19.65c-7.91-6.46-13.33-3.37-13.08,0,.28,3.64,5.14,6.81,10.86,11.09C251.62,332.36,253,340,253,340Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,340l.36-6.65s-.62-12.31-9.61-19.65c-7.91-6.46-13.33-3.37-13.08,0,.28,3.64,5.14,6.81,10.86,11.09C251.62,332.36,253,340,253,340Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.16,337.13a.26.26,0,0,1-.26-.19c-3.62-12.52-13.8-21.42-19.37-24.1a.26.26,0,0,1-.12-.35.27.27,0,0,1,.35-.13c5.65,2.72,16,11.75,19.65,24.43a.27.27,0,0,1-.18.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.53,357.88c-.31.2-6.17,2.34-8.6-.42s.91-7.6-1.3-9.12-7.9.59-9.56-2.84,2.38-5.26-.22-8.65c-1.64-2.14-5.34-3.13-5.81-5.18-.79-3.43,4.84-5.45,10-2.54s8,1.19,9.56.86,4.94-.11,5.24,5.38S253.53,357.88,253.53,357.88Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.34,350.06a.32.32,0,0,1-.34-.24c-2.48-10.26-15.18-17.82-21.59-19.17a.34.34,0,0,1-.26-.39.33.33,0,0,1,.39-.25c6.56,1.38,19.55,9.12,22.1,19.65a.34.34,0,0,1-.24.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.46,342.43a.32.32,0,0,1-.29-.14.33.33,0,0,1,.08-.46c.19-.13,4.63-3.19,9.3-2.26a.33.33,0,0,1,.26.39.33.33,0,0,1-.38.25c-4.4-.87-8.76,2.13-8.8,2.16A.58.58,0,0,1,238.46,342.43Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Computer--inject-188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-188"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186,255.86l-41.13,23.75a7.7,7.7,0,0,0-3.31,4.74l-10.22,59a4.91,4.91,0,0,0,2.22,4.74l26.52,15.31a6.1,6.1,0,0,0,5.52,0l56.68-32.73a5.19,5.19,0,0,0,0-9.17l-20.39-11.78a7,7,0,0,1-3.09-4.76l-4.53-44.53a6.78,6.78,0,0,0-2.92-4.67A5.91,5.91,0,0,0,186,255.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.81,353v11a5.63,5.63,0,0,0,2.76-.66l56.68-32.73A5.9,5.9,0,0,0,225,326.1a5.53,5.53,0,0,0-1.08-3h-9.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.15,258.86,150,282.6a7.73,7.73,0,0,0-3.3,4.74l-9.28,53.57a4.9,4.9,0,0,0,2.22,4.74l20.39,11.77a6.1,6.1,0,0,0,5.52,0l56.68-32.72c1.53-.88,1.53-2.31,0-3.19l-20.39-11.78a7,7,0,0,1-3.09-4.76l-4.53-44.53A1.91,1.91,0,0,0,191.15,258.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.25,321.51l-20.39-11.78a6.28,6.28,0,0,1-2-2l-62,35.8a4.7,4.7,0,0,0,1.83,2.14l20.39,11.77a6.1,6.1,0,0,0,5.52,0l56.68-32.72C223.78,323.82,223.78,322.39,222.25,321.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.27,373.23l-2.63-1.52a8.57,8.57,0,0,1-3.87-6.7V188.39a8.52,8.52,0,0,1,3.88-6.69L268.42,57.82a8.58,8.58,0,0,1,7.74,0l2,1.16a8.55,8.55,0,0,1,3.86,6.7V242.31a8.58,8.58,0,0,1-3.86,6.7L63,373.23A8.58,8.58,0,0,1,55.27,373.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.32,192.9l-14.41-8.32a7.91,7.91,0,0,0-1.14,3.81V365a8.57,8.57,0,0,0,3.87,6.7l2.63,1.52a8.58,8.58,0,0,0,7.74,0l1.31-.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.14,371V194.38a8.53,8.53,0,0,1,3.87-6.7L278.17,63.46c2.13-1.24,3.86-.24,3.86,2.23V242.31a8.58,8.58,0,0,1-3.86,6.7L63,373.23C60.87,374.46,59.14,373.46,59.14,371Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.48,304.51l15.77-9.11c1.18-.68,2.14-.19,2.14,1.08a4.58,4.58,0,0,1-2.14,3.55l-15.77,9.11c-1.18.68-2.13.19-2.13-1.08A4.57,4.57,0,0,1,162.48,304.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.05,193.08,271.68,75.76c1.22-.71,2.21-.14,2.21,1.27V231a4.88,4.88,0,0,1-2.21,3.83l-202.63,117c-1.22.71-2.21.13-2.21-1.28V196.91A4.9,4.9,0,0,1,69.05,193.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-188"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.91,334.64c0,2.54,1.79,3.57,4,2.3L261.84,231.32a8.82,8.82,0,0,0,4-6.91V101.26L74.91,211.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.83,103V224.41a7.86,7.86,0,0,1-3.49,6.05L78.4,336.07a2.67,2.67,0,0,1-1.28.42c-1.09,0-1.21-1.3-1.21-1.85V212.06L264.83,103m1-1.73L74.91,211.49V334.64c0,1.8.9,2.85,2.21,2.85a3.61,3.61,0,0,0,1.78-.55L261.84,231.32a8.82,8.82,0,0,0,4-6.91V101.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.91 211.49 74.91 228.76 265.82 118.54 265.83 101.26 74.91 211.49",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.7,149.1v3.72c0,.76.54,1.07,1.2.69l58.7-33.89v-6.48L195.9,147A2.65,2.65,0,0,0,194.7,149.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.89,109.51c.66-.38,1.19-.07,1.19.69v3.72a2.64,2.64,0,0,1-1.19,2.07l-6.29,3.63v-6.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.42,114.61l-.7-.22a4,4,0,0,0,.11-.91,1.63,1.63,0,0,0-.64-1.49,1,1,0,0,0-1,.05,3.56,3.56,0,0,0-1.4,2.91,1.64,1.64,0,0,0,.64,1.5.88.88,0,0,0,.44.12,1.17,1.17,0,0,0,.58-.17,3,3,0,0,0,1.13-1.51l.71.21.07,0a.27.27,0,0,0,.25-.19A.25.25,0,0,0,260.42,114.61ZM258.17,116a.49.49,0,0,1-.5,0,1.2,1.2,0,0,1-.38-1,3.1,3.1,0,0,1,1.14-2.46.6.6,0,0,1,.32-.1.29.29,0,0,1,.18,0,1.18,1.18,0,0,1,.38,1A3.13,3.13,0,0,1,258.17,116Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.91,203.13a8.82,8.82,0,0,1,4-6.91L261.84,90.6c2.2-1.27,4-.24,4,2.3v8.36L74.91,211.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.37,105.57a4.14,4.14,0,0,0-1.88,3.25c0,1.19.84,1.67,1.88,1.08a4.16,4.16,0,0,0,1.87-3.25C245.24,105.46,244.4,105,243.37,105.57Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92,101.8a4.13,4.13,0,0,0-1.87,3.24c0,1.2.83,1.68,1.87,1.08a4.12,4.12,0,0,0,1.87-3.24C251.79,101.69,251,101.2,249.92,101.8Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.47,98a4.11,4.11,0,0,0-1.87,3.24c0,1.19.83,1.68,1.87,1.08a4.15,4.15,0,0,0,1.87-3.24C258.34,97.92,257.5,97.43,256.47,98Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9,336.94l33.45-19.31V207.15L74.91,228.77V334.64C74.91,337.18,76.7,338.21,78.9,336.94Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.35,208.88V317.05l-32.95,19a2.67,2.67,0,0,1-1.28.42c-1.09,0-1.21-1.3-1.21-1.85V229.34l35.44-20.46m1-1.73L74.91,228.77V334.64c0,1.8.9,2.85,2.21,2.85a3.61,3.61,0,0,0,1.78-.55l33.45-19.31V207.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.34,230.24l17.91-10.36c.66-.38,1.2-.07,1.2.7v1.55a2.66,2.66,0,0,1-1.19,2.08L87.34,234.56c-.66.38-1.2.07-1.2-.69v-1.56A2.65,2.65,0,0,1,87.34,230.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4,234.47V236a2.65,2.65,0,0,1-1.2,2.07l-1.35.78c-.66.38-1.19.07-1.19-.69v-1.56a2.64,2.64,0,0,1,1.19-2.07l1.35-.78C81.86,233.4,82.4,233.71,82.4,234.47Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.34,238.85l17.91-10.35c.66-.38,1.2-.08,1.2.69v1.56a2.64,2.64,0,0,1-1.19,2.07L87.34,243.17c-.66.38-1.2.07-1.2-.69v-1.56A2.65,2.65,0,0,1,87.34,238.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4,243.08v1.56a2.67,2.67,0,0,1-1.2,2.08l-1.35.77c-.66.39-1.19.08-1.19-.69v-1.55a2.64,2.64,0,0,1,1.19-2.08l1.35-.78C81.86,242,82.4,242.32,82.4,243.08Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.34,247.46l17.91-10.35c.66-.38,1.2-.07,1.2.69v1.56a2.64,2.64,0,0,1-1.19,2.07L87.34,251.78c-.66.39-1.2.08-1.2-.69v-1.55A2.65,2.65,0,0,1,87.34,247.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4,251.7v1.56a2.65,2.65,0,0,1-1.2,2.07l-1.35.78c-.66.38-1.19.07-1.19-.69v-1.56a2.64,2.64,0,0,1,1.19-2.07L81.2,251C81.86,250.62,82.4,250.93,82.4,251.7Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.34,264.31,105.25,254c.66-.38,1.2-.07,1.2.69v1.56a2.64,2.64,0,0,1-1.19,2.07L87.34,268.64c-.66.38-1.2.07-1.2-.69v-1.56A2.67,2.67,0,0,1,87.34,264.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4,268.55v1.56a2.65,2.65,0,0,1-1.2,2.07l-1.35.78c-.66.38-1.19.07-1.19-.69v-1.56a2.64,2.64,0,0,1,1.19-2.07l1.35-.78C81.86,267.48,82.4,267.79,82.4,268.55Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.34,271.94l17.91-10.35c.66-.38,1.2-.07,1.2.69v1.56a2.64,2.64,0,0,1-1.19,2.07L87.34,276.26c-.66.39-1.2.08-1.2-.69V274A2.65,2.65,0,0,1,87.34,271.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4,276.18v1.56a2.65,2.65,0,0,1-1.2,2.07l-1.35.78c-.66.38-1.19.07-1.19-.69v-1.56a2.66,2.66,0,0,1,1.19-2.08l1.35-.77C81.86,275.1,82.4,275.41,82.4,276.18Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.14 256.86 86.14 259.55 88.47 256.86 86.14 256.86",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.89,256.31c0,.5.35.7.79.44l15-8.61a1.77,1.77,0,0,0,.8-1.38c0-.5-.36-.71-.8-.45l-15,8.64A1.72,1.72,0,0,0,89.89,256.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,210.37l35.83-20.68c.5-.29.91-.06.91.52v35.45a2,2,0,0,1-.91,1.58L122,247.93c-.51.29-.92,0-.92-.53V212A2,2,0,0,1,122,210.37Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,210.37l35.83-20.68c.5-.29.91-.06.91.52v35.45a2,2,0,0,1-.91,1.58L122,247.93c-.51.29-.92,0-.92-.53V212A2,2,0,0,1,122,210.37Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.74,209.79l-6,10.6,4.21,5.45-13.9-12-12,25.94v7.59c0,.58.41.82.92.53l35.83-20.69a2,2,0,0,0,.91-1.58v-6.73Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.18,198.89c1.49-.86,2.7-.16,2.7,1.56a6,6,0,0,1-2.7,4.67c-1.49.86-2.7.17-2.7-1.55A6,6,0,0,1,150.18,198.89Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.74,182.19l35.83-20.68c.51-.29.91-.06.91.52v35.45a2,2,0,0,1-.91,1.58l-35.83,20.69c-.5.29-.91.05-.91-.53V183.77A2,2,0,0,1,170.74,182.19Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.74,182.19l35.83-20.68c.51-.29.91-.06.91.52v35.45a2,2,0,0,1-.91,1.58l-35.83,20.69c-.5.29-.91.05-.91-.53V183.77A2,2,0,0,1,170.74,182.19Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.49,181.61l-6,10.6,4.21,5.45-13.9-12-12,25.93v7.6c0,.58.41.82.91.53l35.83-20.69a2,2,0,0,0,.91-1.58v-6.73Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.93,170.71c1.49-.86,2.69-.16,2.69,1.56a6,6,0,0,1-2.69,4.67c-1.5.86-2.7.17-2.7-1.56A5.93,5.93,0,0,1,198.93,170.71Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.49,154l35.83-20.69c.5-.29.91-.05.91.53V169.3a2,2,0,0,1-.91,1.58l-35.83,20.69c-.51.29-.92.06-.92-.53V155.6A2,2,0,0,1,219.49,154Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.49,154l35.83-20.69c.5-.29.91-.05.91.53V169.3a2,2,0,0,1-.91,1.58l-35.83,20.69c-.51.29-.92.06-.92-.53V155.6A2,2,0,0,1,219.49,154Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.23,153.44l-6,10.59,4.2,5.46-13.9-12-12,25.94V191c0,.59.41.82.92.53l35.83-20.69a2,2,0,0,0,.91-1.58v-6.72Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,142.53c1.49-.86,2.7-.16,2.7,1.56a6,6,0,0,1-2.7,4.68c-1.49.86-2.7.16-2.7-1.56A6,6,0,0,1,247.67,142.53Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,262l35.83-20.69c.5-.29.91-.06.91.53v35.44a2,2,0,0,1-.91,1.58L122,299.53c-.51.29-.92.05-.92-.53V263.56A2,2,0,0,1,122,262Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,262l35.83-20.69c.5-.29.91-.06.91.53v35.44a2,2,0,0,1-.91,1.58L122,299.53c-.51.29-.92.05-.92-.53V263.56A2,2,0,0,1,122,262Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.74,261.4l-6,10.59,4.21,5.45-13.9-12-12,25.94V299c0,.58.41.82.92.53l35.83-20.69a2,2,0,0,0,.91-1.58v-6.73Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.18,250.49c1.49-.86,2.7-.16,2.7,1.56a6,6,0,0,1-2.7,4.67c-1.49.87-2.7.17-2.7-1.55A6,6,0,0,1,150.18,250.49Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.74,233.79l35.83-20.68c.51-.29.91-.06.91.52v35.45a2,2,0,0,1-.91,1.58l-35.83,20.69c-.5.29-.91,0-.91-.53V235.37A2,2,0,0,1,170.74,233.79Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.74,233.79l35.83-20.68c.51-.29.91-.06.91.52v35.45a2,2,0,0,1-.91,1.58l-35.83,20.69c-.5.29-.91,0-.91-.53V235.37A2,2,0,0,1,170.74,233.79Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.49,233.21l-6,10.6,4.21,5.45-13.9-12-12,25.93v7.6c0,.58.41.82.91.53l35.83-20.69a2,2,0,0,0,.91-1.58v-6.73Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.93,222.31c1.49-.86,2.69-.16,2.69,1.56a6,6,0,0,1-2.69,4.67c-1.5.86-2.7.17-2.7-1.55A5.94,5.94,0,0,1,198.93,222.31Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.49,205.62l35.83-20.69c.5-.29.91-.05.91.53V220.9a2,2,0,0,1-.91,1.58l-35.83,20.69c-.51.29-.92.06-.92-.53V207.2A2,2,0,0,1,219.49,205.62Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.49,205.62l35.83-20.69c.5-.29.91-.05.91.53V220.9a2,2,0,0,1-.91,1.58l-35.83,20.69c-.51.29-.92.06-.92-.53V207.2A2,2,0,0,1,219.49,205.62Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.23,205l-6,10.59,4.2,5.46-13.9-12-12,25.94v7.59c0,.59.41.82.92.53l35.83-20.69a2,2,0,0,0,.91-1.58v-6.72Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,194.14c1.49-.87,2.7-.17,2.7,1.55a6,6,0,0,1-2.7,4.68c-1.49.86-2.7.16-2.7-1.56A6,6,0,0,1,247.67,194.14Z",
    style: {
      fill: "#C53F3F"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-188"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,362.46l-1.74-1a5.66,5.66,0,0,1-2.56-4.43V201.15a5.67,5.67,0,0,1,2.56-4.43l70.26-40.56a5.64,5.64,0,0,1,5.12,0l1.74,1a5.66,5.66,0,0,1,2.55,4.43V317.46a5.66,5.66,0,0,1-2.55,4.43l-70.27,40.57A5.68,5.68,0,0,1,256,362.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,204.14l-9.53-5.51a5.27,5.27,0,0,0-.75,2.52V357a5.66,5.66,0,0,0,2.56,4.43l1.74,1a5.68,5.68,0,0,0,5.11,0L262,362Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.53,205.11V361c0,1.63,1.14,2.29,2.55,1.48l70.27-40.57a5.66,5.66,0,0,0,2.55-4.43V161.59c0-1.63-1.14-2.29-2.55-1.48l-70.27,40.57A5.66,5.66,0,0,0,258.53,205.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.14,216.12,328,179.24c1.21-.7,2.2-.13,2.2,1.27V303.05a4.86,4.86,0,0,1-2.2,3.79l-63.89,36.89c-1.21.69-2.19.13-2.19-1.27V219.92A4.85,4.85,0,0,1,264.14,216.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,184.5c1-.55,1.72-.11,1.72,1a3.76,3.76,0,0,1-1.72,3c-.94.55-1.71.11-1.71-1A3.78,3.78,0,0,1,296.21,184.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.27,193.05c3.48-1.92,9.69-5.62,13.12-7.63.58-.35,1.05-.11,1.05.52a2.24,2.24,0,0,1-1.06,1.76l-13.14,7.59c-.59.34-1.06.1-1.06-.53A2.19,2.19,0,0,1,291.27,193.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,195c.53-.3,1-.06,1,.56a2.11,2.11,0,0,1-1,1.66c-.53.31-1,.06-1-.55A2.16,2.16,0,0,1,288,195Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.82,328.25c2.23-1.29,4-.25,4,2.33a8.9,8.9,0,0,1-4,7c-2.23,1.29-4,.25-4-2.33A8.89,8.89,0,0,1,296.82,328.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,229.8l24.63-14.21c.35-.2.63,0,.63.36v24.36a1.39,1.39,0,0,1-.63,1.09L267,255.61c-.34.2-.62,0-.62-.36V230.89A1.4,1.4,0,0,1,267,229.8Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,229.8l24.63-14.21c.35-.2.63,0,.63.36v24.36a1.39,1.39,0,0,1-.63,1.09L267,255.61c-.34.2-.62,0-.62-.36V230.89A1.4,1.4,0,0,1,267,229.8Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.41,229.4l-4.12,7.29,2.9,3.75-9.56-8.24L266.4,250v5.22c0,.4.28.56.62.36l24.63-14.21a1.39,1.39,0,0,0,.63-1.09v-4.62Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.4,221.91c1-.59,1.85-.11,1.85,1.07a4.1,4.1,0,0,1-1.85,3.21c-1,.6-1.86.12-1.86-1.07A4.09,4.09,0,0,1,286.4,221.91Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.53,210.43l24.62-14.21c.35-.2.63,0,.63.36v24.36a1.39,1.39,0,0,1-.63,1.09l-24.62,14.21c-.35.2-.63,0-.63-.36V211.52A1.39,1.39,0,0,1,300.53,210.43Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.53,210.43l24.62-14.21c.35-.2.63,0,.63.36v24.36a1.39,1.39,0,0,1-.63,1.09l-24.62,14.21c-.35.2-.63,0-.63-.36V211.52A1.39,1.39,0,0,1,300.53,210.43Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.91,210l-4.11,7.28,2.89,3.75-9.56-8.24-8.23,17.83v5.22c0,.4.28.56.63.36L325.15,222a1.39,1.39,0,0,0,.63-1.09v-4.62Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.9,202.54c1-.59,1.85-.11,1.85,1.07a4.1,4.1,0,0,1-1.85,3.21c-1,.6-1.86.12-1.86-1.07A4.09,4.09,0,0,1,319.9,202.54Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,265.27l24.63-14.22c.35-.2.63,0,.63.36v24.37a1.37,1.37,0,0,1-.63,1.08L267,291.08c-.34.2-.62,0-.62-.36V266.36A1.4,1.4,0,0,1,267,265.27Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,265.27l24.63-14.22c.35-.2.63,0,.63.36v24.37a1.37,1.37,0,0,1-.63,1.08L267,291.08c-.34.2-.62,0-.62-.36V266.36A1.4,1.4,0,0,1,267,265.27Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.41,264.87l-4.12,7.28,2.9,3.75-9.56-8.23L266.4,285.5v5.22c0,.4.28.56.62.36l24.63-14.22a1.37,1.37,0,0,0,.63-1.08v-4.63Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.4,257.38c1-.59,1.85-.11,1.85,1.07a4.1,4.1,0,0,1-1.85,3.21c-1,.59-1.86.11-1.86-1.07A4.09,4.09,0,0,1,286.4,257.38Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.53,245.9l24.62-14.22c.35-.2.63,0,.63.36v24.37a1.37,1.37,0,0,1-.63,1.08l-24.62,14.22c-.35.2-.63,0-.63-.36V247A1.39,1.39,0,0,1,300.53,245.9Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.53,245.9l24.62-14.22c.35-.2.63,0,.63.36v24.37a1.37,1.37,0,0,1-.63,1.08l-24.62,14.22c-.35.2-.63,0-.63-.36V247A1.39,1.39,0,0,1,300.53,245.9Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.91,245.5l-4.11,7.28,2.89,3.75-9.56-8.23-8.23,17.83v5.22c0,.4.28.56.63.36l24.62-14.22a1.37,1.37,0,0,0,.63-1.08v-4.63Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.9,238c1-.59,1.85-.11,1.85,1.07a4.1,4.1,0,0,1-1.85,3.21c-1,.59-1.86.11-1.86-1.07A4.09,4.09,0,0,1,319.9,238Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,300.72l24.63-14.22c.35-.2.63,0,.63.36v24.36a1.39,1.39,0,0,1-.63,1.09L267,326.53c-.34.2-.62,0-.62-.36V301.8A1.38,1.38,0,0,1,267,300.72Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,300.72l24.63-14.22c.35-.2.63,0,.63.36v24.36a1.39,1.39,0,0,1-.63,1.09L267,326.53c-.34.2-.62,0-.62-.36V301.8A1.38,1.38,0,0,1,267,300.72Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.41,300.32l-4.12,7.28,2.9,3.75-9.56-8.23L266.4,321v5.22c0,.4.28.56.62.36l24.63-14.22a1.39,1.39,0,0,0,.63-1.09V306.6Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.4,292.83c1-.6,1.85-.12,1.85,1.07a4.1,4.1,0,0,1-1.85,3.21c-1,.59-1.86.11-1.86-1.07A4.09,4.09,0,0,1,286.4,292.83Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.53,281.35l24.62-14.22c.35-.2.63,0,.63.36v24.36a1.39,1.39,0,0,1-.63,1.09l-24.62,14.22c-.35.2-.63,0-.63-.36V282.44A1.39,1.39,0,0,1,300.53,281.35Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.53,281.35l24.62-14.22c.35-.2.63,0,.63.36v24.36a1.39,1.39,0,0,1-.63,1.09l-24.62,14.22c-.35.2-.63,0-.63-.36V282.44A1.39,1.39,0,0,1,300.53,281.35Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.91,281l-4.11,7.28,2.89,3.75-9.56-8.23-8.23,17.83v5.22c0,.4.28.56.63.36l24.62-14.22a1.39,1.39,0,0,0,.63-1.09v-4.62Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.9,273.46c1-.6,1.85-.12,1.85,1.07a4.1,4.1,0,0,1-1.85,3.21c-1,.59-1.86.11-1.86-1.07A4.09,4.09,0,0,1,319.9,273.46Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.23,180.51c0-1.4-1-2-2.2-1.27l-63.89,36.88a4.85,4.85,0,0,0-2.19,3.8V226l68.28-39.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,335.9v6.56c0,1.4,1,2,2.19,1.27L328,306.84a4.86,4.86,0,0,0,2.2-3.79v-6.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sync-icon--inject-188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--sync-icon--inject-188"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.6,237a1,1,0,0,1-.51-1.86l1.3-.75a1,1,0,1,1,1,1.73l-1.3.75A1,1,0,0,1,345.6,237Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.25,233.75a1,1,0,0,1-.5-1.87l2.61-1.5a1,1,0,1,1,1,1.73l-2.61,1.51A1,1,0,0,1,351.25,233.75Zm7-4a1,1,0,0,1-.5-1.87l2.61-1.51a1,1,0,0,1,1,1.74l-2.61,1.5A.9.9,0,0,1,358.21,229.73Zm7-4a1,1,0,0,1-.5-1.87l2.61-1.51a1,1,0,0,1,1.37.37,1,1,0,0,1-.37,1.36l-2.61,1.51A1,1,0,0,1,365.18,225.71Zm7-4a1,1,0,0,1-.86-.5,1,1,0,0,1,.36-1.37l2.62-1.51a1,1,0,0,1,1,1.73l-2.62,1.51A1,1,0,0,1,372.14,221.69Zm7-4a1,1,0,0,1-.5-1.86l2.61-1.51a1,1,0,1,1,1,1.73l-2.61,1.51A1,1,0,0,1,379.11,217.66Zm7-4a1,1,0,0,1-.51-1.86l2.62-1.51a1,1,0,0,1,1,1.73l-2.62,1.51A1,1,0,0,1,386.08,213.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,209.62a1,1,0,0,1-.5-1.87l.8-.46v-.92a1,1,0,0,1,2,0v1.5a1,1,0,0,1-.5.87l-1.3.75A1,1,0,0,1,393,209.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.34,202.44a1,1,0,0,1-1-1v-3a1,1,0,1,1,2,0v3A1,1,0,0,1,394.34,202.44Zm0-7.9a1,1,0,0,1-1-1v-3a1,1,0,1,1,2,0v3A1,1,0,0,1,394.34,194.54Zm0-7.9a1,1,0,0,1-1-1v-3a1,1,0,0,1,2,0v3A1,1,0,0,1,394.34,186.64Zm0-7.9a1,1,0,0,1-1-1v-3a1,1,0,0,1,2,0v3A1,1,0,0,1,394.34,178.74Zm0-7.9a1,1,0,0,1-1-1v-3a1,1,0,0,1,2,0v3A1,1,0,0,1,394.34,170.84Zm0-7.89a1,1,0,0,1-1-1v-3a1,1,0,1,1,2,0v3A1,1,0,0,1,394.34,163Zm0-7.9a1,1,0,0,1-1-1v-3a1,1,0,1,1,2,0v3A1,1,0,0,1,394.34,155.05Zm0-7.9a1,1,0,0,1-1-1v-3a1,1,0,0,1,2,0v3A1,1,0,0,1,394.34,147.15Zm0-7.9a1,1,0,0,1-1-1v-3a1,1,0,0,1,2,0v3A1,1,0,0,1,394.34,139.25Zm0-7.89a1,1,0,0,1-1-1v-3a1,1,0,0,1,2,0v3A1,1,0,0,1,394.34,131.36Zm0-7.9a1,1,0,0,1-1-1v-3a1,1,0,1,1,2,0v3A1,1,0,0,1,394.34,123.46Zm0-7.9a1,1,0,0,1-1-1v-3a1,1,0,1,1,2,0v3A1,1,0,0,1,394.34,115.56Zm0-7.9a1,1,0,0,1-1-1v-3a1,1,0,1,1,2,0v3A1,1,0,0,1,394.34,107.66Zm0-7.89a1,1,0,0,1-1-1v-3a1,1,0,0,1,2,0v3A1,1,0,0,1,394.34,99.77Zm0-7.9a1,1,0,0,1-1-1v-3a1,1,0,0,1,2,0v3A1,1,0,0,1,394.34,91.87Zm0-7.9a1,1,0,0,1-1-1V80a1,1,0,1,1,2,0v3A1,1,0,0,1,394.34,84Zm0-7.9a1,1,0,0,1-1-1v-3a1,1,0,0,1,2,0v3A1,1,0,0,1,394.34,76.07Zm0-7.9a1,1,0,0,1-1-1v-3a1,1,0,1,1,2,0v3A1,1,0,0,1,394.34,68.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.34,60.28a1,1,0,0,1-1-.81,1,1,0,0,1-1.19-.44,1,1,0,0,1,.37-1.37l1.3-.75a1,1,0,0,1,1,0,1,1,0,0,1,.5.87v1.5A1,1,0,0,1,394.34,60.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.32,114.22a1,1,0,0,1-.5-1.87l2.53-1.47a1,1,0,0,1,1,1.74l-2.53,1.46A1,1,0,0,1,298.32,114.22Zm6.76-3.91a1,1,0,0,1-.5-1.87l2.54-1.46a1,1,0,1,1,1,1.73l-2.54,1.47A1,1,0,0,1,305.08,110.31Zm6.77-3.91a1,1,0,0,1-.87-.5,1,1,0,0,1,.37-1.36l2.53-1.47a1,1,0,0,1,1.37.37,1,1,0,0,1-.37,1.36l-2.53,1.47A1,1,0,0,1,311.85,106.4Zm6.76-3.9a1,1,0,0,1-.5-1.87l2.54-1.46a1,1,0,0,1,1.37.36,1,1,0,0,1-.37,1.37l-2.54,1.46A1,1,0,0,1,318.61,102.5Zm6.77-3.91a1,1,0,0,1-.5-1.87l2.54-1.46a1,1,0,0,1,1,1.73l-2.54,1.47A1,1,0,0,1,325.38,98.59Zm6.77-3.91a1,1,0,0,1-.5-1.86l2.53-1.47a1,1,0,0,1,1,1.74l-2.53,1.46A1,1,0,0,1,332.15,94.68Zm6.76-3.9a1,1,0,0,1-.5-1.87L341,87.45a1,1,0,0,1,1.37.36,1,1,0,0,1-.37,1.37l-2.54,1.46A1,1,0,0,1,338.91,90.78Zm6.77-3.91a1,1,0,0,1-.5-1.87l2.53-1.46a1,1,0,0,1,1.37.37,1,1,0,0,1-.37,1.36l-2.53,1.47A1,1,0,0,1,345.68,86.87ZM352.45,83a1,1,0,0,1-.87-.5,1,1,0,0,1,.36-1.36l2.54-1.47a1,1,0,0,1,1,1.74l-2.54,1.46A1,1,0,0,1,352.45,83Zm6.76-3.9a1,1,0,0,1-.5-1.87l2.54-1.46a1,1,0,0,1,1.36.36,1,1,0,0,1-.36,1.37l-2.54,1.46A.93.93,0,0,1,359.21,79.06ZM366,75.15a1,1,0,0,1-.87-.5,1,1,0,0,1,.37-1.36L368,71.82a1,1,0,0,1,1.37.37,1,1,0,0,1-.37,1.36L366.48,75A1,1,0,0,1,366,75.15Zm6.76-3.9a1,1,0,0,1-.5-1.87l2.54-1.46a1,1,0,0,1,1.37.36,1,1,0,0,1-.37,1.37l-2.54,1.46A1,1,0,0,1,372.74,71.25Zm6.77-3.91a1,1,0,0,1-.5-1.87L381.55,64a1,1,0,0,1,1,1.73L380,67.21A1,1,0,0,1,379.51,67.34Zm6.77-3.91a1,1,0,0,1-.51-1.86l2.54-1.47a1,1,0,0,1,1.37.37,1,1,0,0,1-.37,1.36l-2.54,1.47A1,1,0,0,1,386.28,63.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.79,117.41a1,1,0,0,1-.5-1.87l1.3-.75a1,1,0,0,1,1.36.37,1,1,0,0,1-.36,1.36l-1.3.75A1,1,0,0,1,292.79,117.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,29.12l-8.16-4.71h0l-.09-.05h0c-4.07-2.29-9.63-1.95-15.8,1.61-5.77,3.33-11,8.88-15,15.3-4.59,7.39-7.48,16-7.48,23.63,0,7.16,2.51,12.19,6.56,14.54h0l8.29,4.74c4.1,2.61,9.88,2.38,16.29-1.32C407,75.71,417.1,58.28,417.1,43.94,417.1,36.48,414.37,31.33,410,29.12Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.17,84.11,370,79.46h0c-4.05-2.34-6.56-7.37-6.56-14.53,0-7.68,2.89-16.23,7.48-23.63l8.67,5c-4.59,7.39-7.46,15.94-7.46,23.61C372.14,76.74,374.43,81.63,378.17,84.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.83,29c-4-1.94-9.34-1.45-15.21,1.93s-11,8.9-15,15.33l-8.67-5c4-6.43,9.23-12,15-15.3,6.16-3.56,11.74-3.9,15.8-1.61v0l.08.06h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.63,53.28l-2.07-1c3-9.92,0-13.19-5.4-13.65,2.11,1.3,3.18,6.68,1.43,11.77l-2.06-1c-.41-.19-1.08.53-1.09,1.17l-.16,9.58c0,.44.31.59.69.33l8.27-5.73C409.8,54.4,410,53.48,409.63,53.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.32,45.17c0-3.08-.94-5.65-2.32-6.49,0,0-5.64.49-11.07,8.45C389.93,47.13,397.66,40.75,403.32,45.17Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.34,60.53l2.07,1c-3,9.92,0,13.19,5.4,13.64-2.11-1.29-3.18-6.67-1.44-11.76l2.07,1c.41.19,1.07-.53,1.09-1.17l.16-9.58c0-.44-.32-.59-.69-.33L380.73,59C380.17,59.41,379.93,60.33,380.34,60.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.65,68.64c0,3.08.94,5.65,2.31,6.49,0,0,5.65-.49,11.08-8.45C400,66.68,392.31,73.06,386.65,68.64Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-188"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.84,241.81l-11.45,6.65a.62.62,0,0,0-.26.72l8.13,22.29a.4.4,0,0,0,.6.22l10.69-6.17a.65.65,0,0,0,.28-.73L362.43,242A.39.39,0,0,0,361.84,241.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.62 250.02 362.12 244.06 368.43 263.45 358.56 269.02 351.62 250.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,255.6l-.66-.24c.19-2.72-.92-3.58-2.48-3.64a3.46,3.46,0,0,1,1.22,3.18l-.66-.25c-.13-.05-.27.16-.23.33l.61,2.6a.13.13,0,0,0,.23.08l2-1.64C364.16,255.91,364.16,255.65,364,255.6Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.67,253.48a2.71,2.71,0,0,0-1.11-1.74,3.72,3.72,0,0,0-2.58,2.42S359.74,252.34,361.67,253.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.16,257.9l.66.24c-.19,2.73.92,3.58,2.48,3.64a3.43,3.43,0,0,1-1.22-3.17l.66.24c.13,0,.27-.15.23-.33l-.61-2.6a.14.14,0,0,0-.23-.08l-2,1.65C356,257.6,356,257.85,356.16,257.9Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.52,260a2.68,2.68,0,0,0,1.11,1.73,3.69,3.69,0,0,0,2.58-2.41S360.44,261.16,358.52,260Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.67,253.48a2.71,2.71,0,0,0-1.11-1.74,3.72,3.72,0,0,0-2.58,2.42S359.74,252.34,361.67,253.48Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.67,253.48a2.71,2.71,0,0,0-1.11-1.74,3.72,3.72,0,0,0-2.58,2.42S359.74,252.34,361.67,253.48Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.52,260a2.68,2.68,0,0,0,1.11,1.73,3.69,3.69,0,0,0,2.58-2.41S360.44,261.16,358.52,260Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.22,246.55a.26.26,0,0,1-.22-.13.25.25,0,0,1,.09-.34l2.53-1.46a.25.25,0,0,1,.34.09.26.26,0,0,1-.09.35l-2.53,1.45A.19.19,0,0,1,356.22,246.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.51,246.79a.25.25,0,1,1-.25-.24A.25.25,0,0,1,355.51,246.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.79,267.24a.63.63,0,1,1-.63-.63A.63.63,0,0,1,364.79,267.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.15,250.85c3.93-.92,8.24,1.87,10.77,8s7.59,21.89,8.64,26c.47,1.85-13.54,18.18-13,17.94.16-.08-4.56-8-4.56-8l6.8-10.46L424.5,273Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.2,397c.53.2.67,1.21.75,3.23.06,1.52.39,4.18-1.4,4.71s-4.4.26-5.55-1.17c-1.43-1.8-2.39-3.38-4.43-5.57-1.77-1.89-3.68-3.67-4.4-6.33-.64-2.41-.1-3.45,1.54-4.15,2.25-1,5.8,2.18,7.57,2.68C424.8,390.82,428.67,396.79,429.2,397Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.11,390.47a3.09,3.09,0,0,0-2.5,0c-1.7.52-2.2,1.74-.9,3.1s4.49,4.33,4.49,4.33l1.43-3.84Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.79,410.14s.71,2.16,1.09,4c.31,1.49.74,4,.22,5.12s-2.57,1.85-5.74,1.83c-2.05,0-5.25,1.38-7.44,2.6a11.38,11.38,0,0,1-7.1,1c-2.82-.33-5.74-2-6.2-3.13s.13-1.73,6.78-4.56c.06,0,7-3.16,10.21-6.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.4,417,390,418.07c-.17.63.08,1.63,3,2.08,4.51.7,16.08-7.61,16.08-7.61s-.37-1.27-.74-2.35l-5.75.12C399.4,413.86,392.46,417,392.4,417Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.64,360.83a58.38,58.38,0,0,0-3-12.73s1.39-11,2.2-21.47c1.45-18.84.29-25-3.42-33.46,0,0-31.63-3.2-32.59,9.94-1.2,16.37.39,48,.83,53.78s1,8.39,3,20.48c1.56,9.19,4.13,34.16,4.13,34.16,1.05,2.49,7.35,2,8-.83,0,0,2.59-29.55,2.31-36.22a57,57,0,0,0-2.53-14.57s2-26.67,2.54-30.92c0,0,1,8.46,1.42,14.25s2.15,11.3,3.82,22c1.45,9.32,4.85,32.62,4.85,32.62,3,3,5.79,1.14,6-.3C429.2,397.6,432.77,368.91,431.64,360.83Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.95 246.6 405.44 258.82 416.18 257.85 414.95 244.28 403.95 246.6",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,257c-1.18-3.22-5.2-6.8-9.33-6-1.07.2-2,.36-3,.56-.1,2.82-5.4,4.27-10.69,2.57-1.59.45-3,.91-4.37,1.39-3.78,1.35-5.3,7.63-5.38,18.14s-1.64,63.5-1.64,63.5a10.69,10.69,0,0,0,5.46,1l1.46-9.43.69,9.71c3,.49,11.36-.29,16.66-2.06a41.72,41.72,0,0,0,15.54-9.38s-.08-15.23-1.48-22.67-1.8-9.2-8.51-19.56C429.05,269.53,429.73,261.75,428,257Z",
    style: {
      fill: "#C53F3F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428,257c-1.18-3.22-5.2-6.8-9.33-6-1.07.2-2,.36-3,.56-.1,2.82-5.4,4.27-10.69,2.57-1.59.45-3,.91-4.37,1.39-3.78,1.35-5.3,7.63-5.38,18.14s-1.64,63.5-1.64,63.5a10.69,10.69,0,0,0,5.46,1l1.46-9.43.69,9.71c3,.49,11.36-.29,16.66-2.06a41.72,41.72,0,0,0,15.54-9.38s-.08-15.23-1.48-22.67-1.8-9.2-8.51-19.56C429.05,269.53,429.73,261.75,428,257Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "395.1 278.08 401.14 269.38 394.91 284.92 395.1 278.08",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.91,231.53s-4.19-4.73-1.13-9.54c3.6-5.67,10.56-6.63,18.8-4.42a14.62,14.62,0,0,1,10.31,13.27c.39,6-16.46,10.5-16.08,14.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.6,233.37s-2.28,3.67-2,4a5.78,5.78,0,0,0,1.85.74Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.58,221.75c-2.29,1.26-6.23,3.58-7,12.15-.82,8.79,1.21,11.78,2.44,12.9.83.75,5,.92,7.14.19,2.7-.92,8.5-4,11.14-8.58,3.1-5.41,3.58-12.52-.24-15.2C410.65,219.44,404.51,220.69,402.58,221.75Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.9,222.14s-1.8,8.05.76,13c0,0,1.33-3.16,4-2.33s2.58,4.43.5,6.33a4,4,0,0,1-4.16,1,18.12,18.12,0,0,0,4,6.07s8,3.57,14.95-4.26c6.29-7.1,5.12-19.49-4.52-22.41S401.9,222.14,401.9,222.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.01,
    cy: 219.03,
    r: 6.68,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.09,
    cy: 216.47,
    r: 4.06,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.35,
    cy: 224.59,
    r: 4.06,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.66,218.71c-3.46,3.72-3.38,14.17,7,16.46l6.24-18.68C404.91,214,398.75,215.4,395.66,218.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.69,238.06a2,2,0,0,1,1.29-3.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.49,254.81c-4.28,1.28-6.88,1.52-11.61,8.79s-15.43,20.9-16.45,22.63c-1.43,2.42-1.7,6.08-.47,8.3s3.92.85,8.61-3.27c4.53-4,14.1-14.92,14.1-14.92S405.73,266.94,402.49,254.81Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.4,295.55c-4-.48-12.5-12.45-15.13-16.55a29.32,29.32,0,0,0-8-8.45c-4.18-3.09-3.57-7.85-1.75-12.2.64-1.51,2.78-.53,2.78-.53l.76,2.07,1.31,3.58c.89.82,1.39,1.09,1.45.84.11-.46-.65-2.38-.63-4.39,0-2.42,1.71-.83,2.22,0a30.24,30.24,0,0,1,1.78,4c.84,2.16.49,4.35,1.52,5.82s14.82,14.68,14.82,14.68Z",
    style: {
      fill: "#b16668"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBatch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/batch.073d19d1.svg";
export { ForwardRef as ReactComponent };